import React, { useState, useContext, useEffect, useRef } from 'react';
import './departments.scss';
import DepartmentCard from './DepartmentCard';
import ConsejoDirectivo from './Areas/ConsejoDirectivo';
import ConsejoAcademico from './Areas/ConsejoAcademico';
import ConsejoEstudiantil from './Areas/ConsejoEstudiantil';
import Administracion from './Areas/Administracion';
import DesarrolloHumano from './Areas/DesarrolloHumano';
// import PlantaFisica from './Areas/PlantaFisica';
import Tecnologia from './Areas/Tecnologia';
import Direccion from './Areas/Direccion';

import AboutusDeparmentsContext from '../../../../../contexts/pages/aboutus/departments/departmentsContext';

import Slider from '../../../../Globals/Slider';
import InnovacionDocente from './Areas/InnovacionDocente';
import PlanificacionDesarrollo from './Areas/PlanificacionDesarrollo';

const Departments = () => {

    const departmentsContext = useContext(AboutusDeparmentsContext)
    const {
        directiveBoard,
        academicBoard,
        studentsBoard,
        getDepartments } = departmentsContext;

    useEffect(() => {
        if (getDepartments) {
            getDepartments();
        }
        // La carga se realiza una sola vez al montar la sección.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // States from switching between departments
    const [blankState, setBlankState] = useState({
        enter: false,
        active: true
    });
    const [adminState, setAdminState] = useState({
        enter: false,
        active: false
    });
    const [academicBoardState, setAcademicBoardState] = useState({
        enter: false,
        active: false
    });
    const [directiveBoardState, setDirectiveBoardState] = useState({
        enter: false,
        active: false
    });
    const [studentsBoardState, setStudentsBoardState] = useState({
        enter: false,
        active: false
    });
    const [humanDevState, setHumanDevState] = useState({
        enter: false,
        active: false
    });
    const [enlaceState, setEnlaceState] = useState({
        enter: false,
        active: false
    });
    // const [physicalPlantState, setPhysicalPlantState] = useState({
    //     enter: false,
    //     active: false
    // });
    const [eduAdminState, setEduAdminState] = useState({
        enter: false,
        active: false
    });
    const [technologyState, setTechnologyState] = useState({
        enter: false,
        active: false
    });

    const animationStates = {
        blankState,
        setBlankState,
        adminState,
        setAdminState,
        academicBoardState,
        setAcademicBoardState,
        directiveBoardState,
        setDirectiveBoardState,
        studentsBoardState,
        setStudentsBoardState,
        humanDevState,
        setHumanDevState,
        enlaceState,
        setEnlaceState,
        eduAdminState,
        setEduAdminState,
        // physicalPlantState,
        // setPhysicalPlantState,
        technologyState,
        setTechnologyState
    };

    const deptBanner = [
        directiveBoard,
        academicBoard,
        studentsBoard
    ].map((item) => {
        if (Array.isArray(item?.imagen)) {
            return item.imagen[0];
        }
        return item?.imagen;
    }).filter(item => item && item.url);
    const direcciones = [
        'dirección',
        'consejos',
        // 'subdirecciones',
        'docencia e innovación',
        'planificación y desarrollo',
        'orientación',
        'tecnología',
        'administración',
    ];

    const consejos = [
        'directivo',
        'académico',
        'estudiantil'
    ];
    const [choice1, setChoice1] = useState(null)
    const [choice2, setChoice2] = useState(null)

    const contentRef = useRef(null);
    const subConsejosRef = useRef(null);

    const activeDept = choice2 || (choice1 !== 'consejos' ? choice1 : null);

    // Centralizar suavemente el contenido en la pantalla al clickear una card
    useEffect(() => {
        if (activeDept && activeDept !== 'dirección' && contentRef.current) {
            const timer = setTimeout(() => {
                if (contentRef.current) {
                    const rect = contentRef.current.getBoundingClientRect();
                    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                    // Si cabe holgadamente en el viewport, centrarlo; de lo contrario alinear con margen superior
                    if (rect.height < windowHeight * 0.88) {
                        contentRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    } else {
                        const headerOffset = 95;
                        const elementPosition = rect.top + window.pageYOffset;
                        window.scrollTo({
                            top: elementPosition - headerOffset,
                            behavior: 'smooth'
                        });
                    }
                }
            }, 80);
            return () => clearTimeout(timer);
        } else if (choice1 === 'consejos' && !choice2 && subConsejosRef.current) {
            const timer = setTimeout(() => {
                if (subConsejosRef.current) {
                    subConsejosRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }, 80);
            return () => clearTimeout(timer);
        }
    }, [activeDept, choice1, choice2]);

    return (
        // <div className="aboutus-subpage departments">
        //     {departmentsContext ? (<Slider bannerData={deptBanner} />) : null}
        //     <div className="departments-inner">
        //         <div className="departments-title">ORGANISMOS Y DEPARTAMENTOS</div>
        //         <div className="areas">
        //             <div className="row-dept">
        //                 {departments
        //                     ?
        //                     departments.map(department => {
        //                         if (department.titulo.toUpperCase() === "PLANTA FÍSICA") return null

        //                         return (
        //                             <DepartmentCard
        //                                 active={department.titulo === deptState}
        //                                 handleDeptState={()=>handleDeptState(department.titulo)}
        //                                 key={department._id}
        //                                 animationStates={animationStates}
        //                                 title={String(department.titulo).toUpperCase() || ""}
        //                                 text={department.contenido || ""}
        //                             />
        //                         )
        //                     })
        //                     : null
        //                 }
        //             </div>
        //         </div>
        //     </div>
        //     <CSSTransition
        //         in={blankState.active}
        //         timeout={500}
        //         classNames="blank-space"
        //         unmountOnExit
        //         onEnter={() => {
        //             setAdminState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setStudentsBoardState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <Fragment>
        //             <div></div>
        //         </Fragment>
        //     </CSSTransition>
        //     {/* TODO */}
        //     {/* <CSSTransition
        //         in={directiveBoardState.active}
        //         timeout={500}
        //         classNames="directive-board-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setAcademicBoardState({ enter: false, active: false });
        //             setStudentsBoardState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <ConsejoDirectivo />
        //     </CSSTransition> */}

        //     <CSSTransition
        //         in={academicBoardState.active}
        //         timeout={500}
        //         classNames="academic-board-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setStudentsBoardState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <ConsejoAcademico />
        //     </CSSTransition>

        //     <CSSTransition
        //         in={studentsBoardState.active}
        //         timeout={500}
        //         classNames="students-board-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <ConsejoEstudiantil />
        //     </CSSTransition>

        //     <CSSTransition
        //         in={adminState.active}
        //         timeout={500}
        //         classNames="administrative-board-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setStudentsBoardState({ enter: false, active: false });
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <Administracion />
        //     </CSSTransition>

        //     <CSSTransition
        //         in={eduAdminState.active}
        //         timeout={500}
        //         classNames="edu-admin-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setStudentsBoardState({ enter: false, active: false });
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <AdministracionDocente />
        //     </CSSTransition>

        //     <CSSTransition
        //         in={humanDevState.active}
        //         timeout={500}
        //         classNames="human-dev-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setStudentsBoardState({ enter: false, active: false });
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <DesarrolloHumano />
        //     </CSSTransition>

        //     <CSSTransition
        //         in={enlaceState.active}
        //         timeout={500}
        //         classNames="enlace-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setStudentsBoardState({ enter: false, active: false });
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (humanDevState.enter) setHumanDevState({ ...humanDevState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <Enlace />
        //     </CSSTransition>

        //     {/* <CSSTransition
        //         in={physicalPlantState.active}
        //         timeout={500}
        //         classNames="physical-plant-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setStudentsBoardState({ enter: false, active: false });
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             setTechnologyState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (humanDevState.enter) setEnlaceState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             if (technologyState.enter) setTechnologyState({ ...technologyState, active: true });
        //         }}
        //     >
        //         <PlantaFisica />
        //     </CSSTransition> */}

        //     <CSSTransition
        //         in={technologyState.active}
        //         timeout={500}
        //         classNames="technology-dpt"
        //         unmountOnExit
        //         onEnter={() => {
        //             setBlankState({ enter: false, active: false });
        //             setEduAdminState({enter:false,active: false});
        //             setStudentsBoardState({ enter: false, active: false });
        //             setDirectiveBoardState({ enter: false, active: false });
        //             setAcademicBoardState({ enter: false, active: false });
        //             setAdminState({ enter: false, active: false });
        //             setHumanDevState({ enter: false, active: false });
        //             setEnlaceState({ enter: false, active: false });
        //             // setPhysicalPlantState({ enter: false, active: false });
        //         }}
        //         onExited={() => {
        //             if (blankState.enter) setBlankState({ ...blankState, active: true });
        //             if (eduAdminState.enter) setEduAdminState({ ...eduAdminState, active: true });
        //             if (studentsBoardState.enter) setStudentsBoardState({ ...studentsBoardState, active: true });
        //             if (directiveBoardState.enter) setDirectiveBoardState({ ...directiveBoardState, active: true });
        //             if (academicBoardState.enter) setAcademicBoardState({ ...academicBoardState, active: true });
        //             if (adminState.enter) setAdminState({ ...adminState, active: true });
        //             if (humanDevState.enter) setEnlaceState({ ...humanDevState, active: true });
        //             if (enlaceState.enter) setEnlaceState({ ...enlaceState, active: true });
        //             // if (physicalPlantState.enter) setPhysicalPlantState({ ...physicalPlantState, active: true });
        //         }}
        //     >
        //         <Tecnologia />
        //     </CSSTransition>
        // </div >
        <div className="aboutus-subpage departments">
            {departmentsContext ? (<Slider bannerData={deptBanner} />) : null}
            <div className="departments-inner">
                <div className="departments-title">ORGANISMOS Y DEPARTAMENTOS</div>
                <div className="areas">
                    <div className="row-dept">
                        {direcciones
                            ?
                            direcciones.map((dir) => {

                                const active = choice1 === dir
                                return (
                                    <DepartmentCard
                                        key={dir}
                                        active={active}
                                        handleDeptState={() => {
                                            setChoice1(dir)
                                            setChoice2(null)
                                        }}
                                        animationStates={animationStates}
                                        title={String(dir).toUpperCase() || ""}
                                        text={dir || ""}
                                        // inactive={!!choice2 && !active}
                                        inactive={!active && choice1 === 'consejos'}
                                        secondary={!!choice2 && active}
                                    />
                                )
                            })
                            : null
                        }
                    </div>
                    {['consejos'].includes(choice1) && <hr />}
                    <div className="row-dept row-dept-sub" ref={subConsejosRef}>
                        {
                            (['consejos'].includes(choice1))
                                ?
                                (consejos.map((consejo) => (
                                    <DepartmentCard
                                        key={consejo}
                                        active={choice2 === consejo}
                                        handleDeptState={() => setChoice2(consejo)}
                                        animationStates={animationStates}
                                        title={String(consejo).toUpperCase() || ""}
                                        text={consejo || ""}
                                    />
                                )
                                ))
                                : <div className='row-dept'/>
                        }
                    </div>
                    {activeDept && activeDept !== 'dirección' && (
                        <div
                            ref={contentRef}
                            className="department-active-content"
                            key={activeDept}
                        >
                            <ShowMembersOf department={activeDept} />
                        </div>
                    )}

                </div>
            </div>

        </div >
    )
}

function ShowMembersOf({department}) {
    // return department
    switch (department) {
        case 'dirección':
            return <Direccion />
        case 'tecnología':
            return <Tecnologia />
        case 'administración':
            return <Administracion />
        case 'académico':
            return <ConsejoAcademico />
        case 'estudiantil':
            return <ConsejoEstudiantil />
        case 'directivo':
            return <ConsejoDirectivo />
        case 'desarrollo humano':
        case 'orientación':
            return <DesarrolloHumano />
        case 'planificación y desarrollo':
            return <PlanificacionDesarrollo />
        case 'docencia e innovación':
            return <InnovacionDocente />

        default:
            return (<div></div>)
    }
}

export default Departments;
